module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("First published in the United States in 2018 by Chronicle Books LLC.")]), _vm._v(" "), _c('p', [_vm._v("First published in the United Kingdom in 2017 by Ebury Press."), _c('br'), _vm._v("Copyright © 2017, 2018 by Stephen Wildish. All Rights Reserved."), _c('br'), _vm._v("No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN: 978-1-4521-6779-4 (epub, mobi)")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data is available.")]), _vm._v(" "), _c('p', [_vm._v("ISBN: 978-1-4521-6776-3 (hc)")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, CA 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books publishes distinctive books and gifts. From award-winning children’s titles, bestselling cookbooks, and eclectic pop culture to acclaimed works of art and design, stationery, and journals, we craft publishing that’s instantly recognizable for its spirit and creativity. Enjoy our publishing and become part of our community at "), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725bdf56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04copyright.vue
// module id = 66
// module chunks = 0